module.exports = __webpack_public_path__ + "img/male.ea70805c.svg";